import { lighten, makeStyles } from "@material-ui/core";

export const PRICING_TABLE_STYLE = {
  borderCollapse: "separate",
  width: "max-content"
};

export const PRICING_ALIGNED_CONTENT_STYLE = {
  width: "fit-content",
  maxWidth: "100%",
  marginLeft: "auto",
  marginRight: "auto"
};

export const PRICING_PAPER_STYLE = {
  width: "fit-content",
  maxWidth: "100%"
};

export const PRICING_TABLE_CONTAINER_STYLE = {
  maxWidth: "100%",
  overflowX: "auto"
};

export const getPricingTableHeadBg = theme =>
  lighten(theme.palette.primary.main, 0.93);

export const PRICING_STICKY_LAST_SHADOW = "4px 0 6px -2px rgba(0, 0, 0, 0.12)";
export const PRICING_STICKY_LAST_BORDER = "1px solid #e0e0e0";

export const PRICING_STICKY_COLUMNS = {
  checkbox: { width: 64, left: 0 },
  product_base_id: { width: 56, left: 64 },
  nome_produto: { width: 200, left: 120 },
  curva: { width: 68, left: 320 },
  parecer_gemini: { width: 88, left: 388, isLast: true }
};

const stickyColumnBox = width => ({
  width,
  minWidth: width,
  maxWidth: width,
  boxSizing: "border-box"
});

const stickyLastColumnExtras = showLastSeparator =>
  showLastSeparator
    ? {
        boxShadow: PRICING_STICKY_LAST_SHADOW,
        borderRight: PRICING_STICKY_LAST_BORDER
      }
    : {};

export const buildPricingStickyHeadStyle = (
  left,
  width,
  headBackground,
  showLastSeparator = false
) => ({
  ...stickyColumnBox(width),
  position: "sticky",
  left,
  zIndex: 4,
  backgroundColor: headBackground,
  ...stickyLastColumnExtras(showLastSeparator)
});

export const buildPricingStickyCellStyle = (
  left,
  width,
  backgroundColor,
  showLastSeparator = false
) => ({
  ...stickyColumnBox(width),
  position: "sticky",
  left,
  zIndex: 2,
  backgroundColor,
  ...stickyLastColumnExtras(showLastSeparator)
});

export const getPricingRowBackground = (
  row,
  rowIndex,
  { confirmedRows, editedPrices, editedAmeixaPrices, editedPromo }
) => {
  if (confirmedRows.includes(row.id)) return "#f1f8e9";
  if (editedAmeixaPrices[row.id] !== undefined) return "#e3f2fd";
  if (editedPrices[row.id] !== undefined) return "#fffde7";
  if (editedPromo[row.product_base_id] !== undefined) return "#f3e5f5";
  if (rowIndex % 2 === 0) return "#f5f5f5";
  return "#ffffff";
};

export const useStyles = makeStyles(() => ({
  /* ---- Campo de preço final editável ---- */
  priceInput: {
    "& .MuiOutlinedInput-input": {
      padding: "6px 6px 6px 2px",
      width: "72px",
      textAlign: "right"
    },
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: "8px"
    }
  },

  warningText: {
    color: "#e65100",
    fontSize: "0.72rem",
    marginTop: "2px"
  },

  /* ---- Variação de preço (Δ) ---- */
  deltaPositive: {
    color: "#2e7d32",
    fontWeight: 600
  },
  deltaNegative: {
    color: "#c62828",
    fontWeight: 600
  },
  deltaNeutral: {
    color: "#757575",
    fontWeight: 600
  },

  /* ---- Markup ---- */
  markupBom: {
    color: "#2e7d32",
    fontWeight: 600
  },
  markupRuim: {
    color: "#c62828",
    fontWeight: 600
  },

  /* ---- Badge de promoção ---- */
  promoBadge: {
    backgroundColor: "#fff3e0",
    color: "#e65100",
    borderRadius: "4px",
    padding: "2px 8px",
    fontSize: "0.75rem",
    fontWeight: 600
  },

  /* ---- Badges de curva ---- */
  flagBadge: {
    display: "inline-block",
    borderRadius: "4px",
    padding: "2px 8px",
    fontSize: "0.72rem",
    fontWeight: 600,
    whiteSpace: "nowrap"
  },
  badgeSuccess: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32"
  },
  badgeWarning: {
    backgroundColor: "#fff8e1",
    color: "#f57f17"
  },
  badgeFail: {
    backgroundColor: "#fce4ec",
    color: "#c62828"
  },
  badgeNeutral: {
    backgroundColor: "transparent",
    color: "#757575",
    padding: 0,
    borderRadius: 0
  },

  stickyProductName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
}));
